import { render, staticRenderFns } from "./temperature-slider.component.vue?vue&type=template&id=3b4d6752&"
import script from "./temperature-slider.component.vue?vue&type=script&lang=js&"
export * from "./temperature-slider.component.vue?vue&type=script&lang=js&"
import style0 from "./temperature-slider.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports